/* TinyWolf plan builder. Port of the live Lovable quiz (planbuilder-v3): same questions, values, maths,
   result link, Supabase row and Klaviyo payload. Change from live: activity levels 4 and 5 are no longer
   clamped to 3 (Guy, 6 Oct 2026). */
(function () {
  var root = document.querySelector('[data-twq]');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  var cfg = {};
  try { cfg = JSON.parse(document.querySelector('[data-twq-config]').textContent); } catch (e) {}

  /* ---------- constants (calculationUtils.ts, subscriptionCalculator.ts) ---------- */
  var KCAL_PER_G = 3.569, G_PER_CUP = 125;
  var LSF = { Growth1: 3.0, Growth1_5: 2.5, Growth2: 2.0, AdultIntact: 1.6, AdultNeutered: 1.4, AdultLoss: 0.7, AdultGain: 1.8,
    Senior: 1.2, SeniorLoss: 0.8, SeniorGain: 1.5, Gestation: 3.0, Lactation: 4.0 };
  var ACT = { 1: 0.7, 2: 0.8, 3: 0.9, 4: 1.0, 5: 1.1 };
  var BAG_G = [0, 2041, 4082, 6123, 8164, 10205, 12247];
  var LADDER = { 1: [1, 2, 3], 2: [2, 3, 4], 3: [2, 3, 4], 4: [3, 4, 5], 5: [4, 5, 6], 6: [4, 5, 6] };
  var MIN_D = 7, MAX_D = 68;

  var AGES = { '0.25': ['0-4 months', 'Puppy'], '0.5': ['5-8 months', 'Puppy'], '0.75': ['9-12 months', 'Junior'], '4': ['1-7 years', 'Adult'], '8': ['8+ years', 'Senior'] };
  var ACTS = { 1: ['Couch potato', '< 30 mins', 'Less than 30 mins'], 2: ['Regular walker', '30-60 mins', '30-60 mins'], 3: ['Active explorer', '1-2 hrs', '1-2 hrs'],
    4: ['Daily Hiker', '2-3 hrs', '2-3 hrs'], 5: ['Trail Warrior', '3+ hrs', '3+ hrs'] };

  var IC = {
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>', pulse: '<path d="M3 12h4l3-7 4 14 3-7h4"/>', check: '<path d="M5 12l5 5 9-10"/>', drop: '<path d="M12 3s6 7 6 11a6 6 0 0 1-12 0c0-4 6-11 6-11z"/>',
    weight: '<path d="M6 8h12l2 12H4z"/><path d="M9 8a3 3 0 0 1 6 0"/>', wind: '<path d="M3 8h11a3 3 0 1 0-3-3M3 12h15a3 3 0 1 1-3 3M3 16h8"/>',
    heart: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>', shield: '<path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/>',
    spark: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8"/>',
    alert: '<circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5h.01"/>', moon: '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>'
  };
  function icon(n) { return '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (IC[n] || IC.check) + '</svg>'; }

  /* Health goals: ids and labels as live (they map to Supabase/Klaviyo columns). Copy uses the "Legal" column of the Health Goals sheet. */
  var DIGEST = 'Probiotics, prebiotics and fiber help support healthy digestion and a healthy gut.';
  var GOALS = [
    ['more-energy', 'More Energy', 'pulse', 'Salmon Oil', 'DHA to support cognitive health.'],
    ['picky-eater', 'Picky Eater', 'check', 'Real beef muscle & offal', 'Rich in natural flavors and fats to satisfy even the pickiest eaters.'],
    ['soothe-stomach', 'Soothe Stomach', 'drop', 'Probiotics, Prebiotics & Natural Fiber', DIGEST],
    ['healthy-weight', 'Healthy Weight', 'weight', 'L-Carnitine', 'Fortified with L-Carnitine to support heart health.'],
    ['reduce-joint-pain', 'Reduce Joint Pain', 'pulse', 'Flaxseeds & Salmon Oil', 'Balanced omega-3s and 6s help support your dog’s joint health.'],
    ['reduce-gas', 'Reduce Gas', 'wind', 'Probiotics, Prebiotics & Natural Fiber', DIGEST],
    ['overall-health', 'Overall Health', 'heart', 'Complete & Balanced', 'Real beef is the No. 1 ingredient, and fiber helps support healthy digestion and a healthy gut.'],
    ['boost-immunity', 'Boost Immunity', 'shield', 'Blueberries & Cranberries', 'Antioxidants support a healthy immune system.'],
    ['soft-coat', 'Soft Coat', 'spark', 'Flaxseeds & Salmon Oil', 'Balanced omega-3s and 6s to support a healthy coat.'],
    ['soothe-itching', 'Soothe Itching', 'pulse', 'Flaxseeds & Salmon Oil', 'Balanced omega-3s and 6s to support healthy skin.'],
    ['tackle-allergies', 'Tackle Allergies', 'alert', 'Blueberries & Cranberries', 'Antioxidants support a healthy immune system.'],
    ['calming', 'Calming', 'moon', 'Salmon Oil', 'DHA to support cognitive health.'],
    ['better-shts', 'Better Sh*ts', 'check', 'Probiotics, Prebiotics & Natural Fiber', DIGEST]
  ];
  var GOAL = {}; GOALS.forEach(function (g) { GOAL[g[0]] = g; });

  var BREEDS = ['Mixed Breed', 'Afghan Hound', 'Airedale Terrier', 'Akita', 'Alaskan Malamute', 'American Eskimo Dog', 'American Hairless Terrier', 'American Staffordshire Terrier',
    'Anatolian Shepherd Dog', 'Australian Cattle Dog', 'Australian Shepherd', 'Basenji', 'Basset Hound', 'Beagle', 'Bearded Collie', 'Bedlington Terrier', 'Belgian Laekenois',
    'Belgian Malinois', 'Belgian Sheepdog (Groenendael)', 'Belgian Tervuren', 'Bernese Mountain Dog', 'Bichon Frise', 'Bloodhound', 'Boerboel', 'Bolognese', 'Border Collie',
    'Border Terrier', 'Borzoi', 'Boston Terrier', 'Bouvier des Flandres', 'Boxer', 'Bracco Italiano', 'Brittany', 'Brussels Griffon', 'Bullmastiff', 'Cairn Terrier', 'Cane Corso',
    'Canadian Eskimo Dog', 'Cardigan Welsh Corgi', 'Cavalier King Charles Spaniel', 'Chesapeake Bay Retriever', 'Chihuahua', 'Chinese Shar-Pei', 'Chow Chow', 'Clumber Spaniel',
    'Cockapoo', 'Cocker Spaniel', 'Collie', 'Curly-Coated Retriever', 'Dachshund', 'Dandie Dinmont Terrier', 'Doberman Pinscher', 'Dogo Argentino', 'English Bulldog',
    'English Cocker Spaniel', 'English Foxhound', 'English Setter', 'English Springer Spaniel', 'English Toy Terrier', 'Estrela Mountain Dog', 'Eurasier', 'Field Spaniel',
    'Finnish Lapphund', 'Finnish Spitz', 'Flat-Coated Retriever', 'French Bulldog', 'German Shepherd', 'German Shorthaired Pointer', 'Glen of Imaal Terrier', 'Goldendoodle',
    'Golden Retriever', 'Gordon Setter', 'Great Dane', 'Greater Swiss Mountain Dog', 'Greyhound', 'Havanese', 'Hovawart', 'Ibizan Hound', 'Irish Red and White Setter',
    'Irish Setter', 'Irish Terrier', 'Irish Water Spaniel', 'Italian Greyhound', 'Jack Russell Terrier', 'Japanese Chin', 'Japanese Spitz', 'Keeshond', 'Kerry Blue Terrier',
    'Kooikerhondje', 'Labradoodle', 'Labrador Retriever', 'Lagotto Romagnolo', 'Lakeland Terrier', 'Leonberger', 'Lhasa Apso', 'Lurcher', 'Maltese', 'Maltipoo',
    'Manchester Terrier', 'Mastiff', 'Miniature Bull Terrier', 'Miniature Schnauzer', 'Neapolitan Mastiff', 'Newfoundland', 'Norfolk Terrier', 'Norwegian Elkhound',
    'Norwich Terrier', 'Nova Scotia Duck Tolling Retriever', 'Old English Sheepdog', 'Otterhound', 'Papillon', 'Parson Russell Terrier', 'Patterdale Terrier', 'Pekingese',
    'Pembroke Welsh Corgi', 'Petit Basset Griffon Vendéen', 'Pharaoh Hound', 'Pointer', 'Pomeranian', 'Poodle', 'Portuguese Water Dog', 'Pug', 'Rat Terrier',
    'Redbone Coonhound', 'Rhodesian Ridgeback', 'Rottweiler', 'Saint Bernard', 'Saluki', 'Samoyed', 'Schipperke', 'Scottish Terrier', 'Sealyham Terrier', 'Setter (Irish)',
    'Shar-Pei', 'Shetland Sheepdog', 'Shiba Inu', 'Shih Tzu', 'Siberian Husky', 'Silky Terrier', 'Skye Terrier', 'Sloughi', 'Smooth Fox Terrier', 'Soft Coated Wheaten Terrier',
    'Spanish Water Dog', 'Spinone Italiano', 'Springer Spaniel', 'Staffordshire Bull Terrier', 'St. Bernard', 'Sussex Spaniel', 'Swedish Vallhund', 'Thai Ridgeback',
    'Tibetan Mastiff', 'Tibetan Terrier', 'Toy Fox Terrier', 'Treeing Walker Coonhound', 'Vizsla', 'Weimaraner', 'Welsh Springer Spaniel', 'Welsh Terrier',
    'West Highland White Terrier', 'Whippet', 'Wirehaired Pointing Griffon', 'Xoloitzcuintli', 'Yorkshire Terrier', 'Other'];

  var STEP_NAMES = ['', 'Basic Info', 'Physical Details', 'Additional Info', 'Reproduction Info', 'Health Goals', 'Marketing Opt-In'];
  var SKEY = 'tw_quiz_v1';

  /* ---------- state ---------- */
  var st = { step: 1, name: '', gender: '', age: '', breed: '', weight: 10, weightStatus: '', activity: 2, neutered: '', repro: 'none', goals: [], email: '', result: null };
  try { var saved = JSON.parse(sessionStorage.getItem(SKEY) || 'null'); if (saved && saved.v === 1) st = Object.assign(st, saved.s); } catch (e) {}
  function save() { try { sessionStorage.setItem(SKEY, JSON.stringify({ v: 1, s: st })); } catch (e) {} }

  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function nm() { return st.name.trim(); }
  function poss(cap) { return nm() ? nm() + '’s' : (cap ? 'Your dog’s' : 'your dog’s'); }
  function validEmail(e) { return !e || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }

  /* ---------- analytics: the quiz's own GA4 property and the site's, plus a Shopify custom event ---------- */
  var gaIds = [cfg.gaQuiz, cfg.gaSite].filter(Boolean);
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') { window.gtag = function () { window.dataLayer.push(arguments); }; }
  if (cfg.gaQuiz) {
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      var gs = document.createElement('script'); gs.async = true; gs.src = 'https://www.googletagmanager.com/gtag/js?id=' + cfg.gaQuiz; document.head.appendChild(gs);
      window.gtag('js', new Date());
    }
    window.gtag('config', cfg.gaQuiz);
  }
  function track(name, params) {
    params = params || {};
    try { gaIds.forEach(function (id) { window.gtag('event', name, Object.assign({ send_to: id }, params)); }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('tw_' + name, params); } catch (e) {}
  }
  function trackStep(n, action) {
    if (n < 1 || n > 6) return;
    track('form_step_' + action, { step_number: n, step_name: STEP_NAMES[n], event_category: 'Dog Profile Form', event_label: 'Step ' + n + ': ' + STEP_NAMES[n] });
  }

  /* ---------- maths ---------- */
  function lifeStage(p) {
    var a = p.age, w = p.weightStatus, neut = p.neutered === 'yes', fem = p.gender === 'female';
    if (a <= 0.25) return LSF.Growth1;
    if (a <= 0.5) return LSF.Growth1_5;
    if (a < 1) return LSF.Growth2;
    var preg = fem && !neut && !!p.repro && p.repro !== 'none';
    if (preg) return LSF.Gestation;
    if (a < 8) {
      if (w === 'Underweight') return LSF.AdultGain;
      if (w === 'Overweight') return LSF.AdultLoss;
      return neut ? LSF.AdultNeutered : LSF.AdultIntact;
    }
    if (w === 'Underweight') return LSF.SeniorGain;
    if (w === 'Overweight') return LSF.SeniorLoss;
    return LSF.Senior;
  }
  function daily(p) {
    var kg = p.weight / 2.20462, rer = 70 * Math.pow(kg, 0.75);
    var kcal = Math.round(rer * lifeStage(p) * (ACT[p.activity] || 0.8));
    return { kcal: kcal, grams: Math.round(kcal / KCAL_PER_G) };
  }
  function buffer(raw) { return Math.min(3, Math.max(2, Math.floor(raw * 0.10))); }
  function planFor(bags, g) {
    var raw = BAG_G[bags] / g, days = Math.max(MIN_D, Math.min(MAX_D, Math.floor(raw - buffer(raw))));
    return { bags: bags, variant: String(cfg.variants && cfg.variants[bags] || ''), sellingPlan: String(cfg.plans && cfg.plans[days] || ''), days: days, rawDays: Math.floor(raw), ok: Math.floor(raw - buffer(raw)) >= MIN_D && Math.floor(raw - buffer(raw)) <= MAX_D };
  }
  function plans(g) {
    var best = 1, dist = Infinity;
    for (var b = 1; b <= 6; b++) { var d = Math.abs(BAG_G[b] / g - 28); if (d < dist || (d === dist && b > best)) { dist = d; best = b; } }
    var all = LADDER[best].map(function (b) { return planFor(b, g); });
    return { all: all, valid: all.filter(function (x) { return x.ok; }) };
  }
  function planUrl(valid, id) {
    var def = valid.length >= 2 ? valid[1] : valid[valid.length - 1];
    var q = new URLSearchParams();
    if (def) { q.set('variant', def.variant); q.set('selling_plan', def.sellingPlan); }
    valid.forEach(function (x, i) { q.set('plan' + (i + 1) + '_variant', x.variant); q.set('plan' + (i + 1) + '_selling_plan', x.sellingPlan); q.set('plan' + (i + 1) + '_days', String(x.days)); });
    if (nm()) q.set('dog_name', nm());
    if (st.breed) q.set('dog_breed', st.breed);
    var t = AGES[String(st.age)]; if (t) q.set('age_title', t[1]);
    q.set('dog_weight', String(Math.round(st.weight)));
    return cfg.productUrl + '?' + q.toString() + (id ? '&profile=' + id : '');
  }

  /* ---------- saving: same row and payload as formSubmissionUtils.ts + klaviyo/profileMapper.ts ---------- */
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
  }
  function goalCols(prefix) { var o = {}; GOALS.forEach(function (g) { o[prefix + g[0].replace(/-/g, '_')] = st.goals.indexOf(g[0]) > -1; }); return o; }
  function preg() { return st.gender === 'female' && st.neutered !== 'yes' && !!st.repro && st.repro !== 'none'; }
  function sbHeaders() { return { 'Content-Type': 'application/json', apikey: cfg.sbKey, Authorization: 'Bearer ' + cfg.sbKey }; }
  function withTimeout(pr, ms) { return Promise.race([pr, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]); }

  function submit(withEmail) {
    var email = withEmail ? st.email.trim().toLowerCase() : '';
    if (!withEmail) st.email = '';
    var optIn = !!email;
    var d = daily(st), pl = plans(d.grams), id = uuid(), url = planUrl(pl.valid, id);
    var row = Object.assign({
      id: id, name: nm(), gender: st.gender || 'unknown', neutered: st.neutered === 'yes', breed: st.breed, age: Number(st.age), weight: st.weight,
      activity_score: st.activity, isPregnantOrLactating: preg(), weight_status: st.weightStatus || null, email: email || null,
      marketing_opt_in: optIn, recommended_grams: d.grams, daily_calories: d.kcal, plan_url: url
    }, goalCols('health_goal_'));
    var started = Date.now();
    show('load');
    var jobs = Promise.resolve();
    if (cfg.sbUrl && cfg.sbKey) {
      jobs = withTimeout(fetch(cfg.sbUrl.replace(/\/$/, '') + '/rest/v1/dog_profiles', {
        method: 'POST', headers: Object.assign(sbHeaders(), { Prefer: 'return=minimal' }), body: JSON.stringify(row), keepalive: true
      }), 10000).then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error('save ' + r.status + ' ' + t); });
        if (!email) return;
        var kl = {
          email: email,
          properties: Object.assign({
            dog_name: nm(), dog_breed: st.breed, dog_age: Number(st.age), dog_weight: st.weight, dog_gender: st.gender, dog_activity_level: st.activity,
            dog_neutered: st.neutered === 'yes', dog_weight_status: st.weightStatus, dog_pregnant_or_lactating: preg(),
            dog_reproductive_status: st.neutered === 'yes' ? 'none' : (st.gender === 'female' ? (st.repro === 'none' ? 'none' : 'pregnant_or_nursing') : undefined)
          }, goalCols('dog_health_goal_'), {
            dog_food_recommendation_grams: d.grams, dog_food_recommendation_calories: d.kcal, plan_url: url, marketing_opt_in: optIn, $source: 'Dog Food Calculator'
          }),
          consent: optIn ? ['email'] : [],
          marketingOptIn: optIn
        };
        return withTimeout(fetch(cfg.sbUrl.replace(/\/$/, '') + '/functions/v1/' + (cfg.sbFn || 'klaviyo-sync'), {
          method: 'POST', headers: sbHeaders(), body: JSON.stringify(kl), keepalive: true
        }), 8000).catch(function (e) { if (window.console) console.warn('[TinyWolf quiz] Klaviyo sync failed', e); });
      }).catch(function (e) { if (window.console) console.warn('[TinyWolf quiz] save failed', e); });
    }
    jobs.then(function () {
      setTimeout(function () {
        track('form_submit_success', { event_category: 'Dog Profile Form', event_label: 'Form Completed', has_email: optIn, marketing_opt_in: optIn });
        st.result = { kcal: d.kcal, grams: d.grams, url: url, plans: pl.valid, all: pl.all };
        go(7);
      }, Math.max(0, 600 - (Date.now() - started)));
    });
  }

  /* ---------- rendering ---------- */
  function fillNames() {
    $$('[data-np]').forEach(function (e) { if (!e.dataset.d) e.dataset.d = e.textContent; e.textContent = poss(/^[A-Z]/.test(e.dataset.d)); });
    $$('[data-np-up]').forEach(function (e) { e.textContent = poss(true); });
    $$('[data-nn]').forEach(function (e) { e.textContent = nm() || 'your dog'; });
    $$('[data-nn-up]').forEach(function (e) { e.textContent = nm() || 'Your dog'; });
    var neut = $('[data-neut]');
    if (neut) neut.textContent = nm() ? 'Is ' + nm() + (st.gender === 'female' ? ' Spayed?' : ' Neutered?') : 'Is your dog neutered/spayed?';
    $$('[data-tpl]').forEach(function (e) {
      if (!e.dataset.raw) e.dataset.raw = e.textContent;
      e.textContent = e.dataset.raw.replace(/\[name\]/g, nm() || 'your dog');
    });
  }
  function syncChoices() {
    $$('[data-f][data-v]').forEach(function (b) {
      var f = b.dataset.f, on = String(st[f]) === b.dataset.v;
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var p = $('[data-preg]'); if (p) p.hidden = !(st.gender === 'female' && st.neutered === 'no');
  }
  function stepOk(n) {
    if (n === 1) return !!(nm() && st.gender && st.age !== '');
    if (n === 2) return !!(st.breed && st.weight > 0 && st.weight <= 220);
    if (n === 3) return !!(st.weightStatus && st.activity >= 1 && st.activity <= 5);
    if (n === 4) return !!st.neutered;
    if (n === 6) return validEmail(st.email.trim());
    return true;
  }
  function refresh() {
    fillNames(); syncChoices();
    $$('[data-pane="' + st.step + '"] [data-next], [data-pane="' + st.step + '"] [data-submit]').forEach(function (b) { b.disabled = !stepOk(st.step); });
    var bn = $('[data-bar-next]'); if (bn) bn.disabled = !stepOk(st.step);
    var e = st.email.trim(), okE = $('[data-email-ok]'), errE = $('[data-email-err]');
    if (okE) okE.hidden = !(e && validEmail(e));
    if (errE) errE.hidden = !(e && !validEmail(e) && e.indexOf('@') > -1 && e.length > 5);
    var gc = $('[data-goal-count]'); if (gc) { gc.hidden = !st.goals.length; gc.querySelector('span').textContent = st.goals.length + ' selected. Pick as many as you like.'; }
    if (st.step === 4) {
      var chips = [st.gender === 'female' ? 'Good girl' : 'Good boy', (AGES[String(st.age)] || [''])[0], st.breed, Math.round(st.weight) + ' lbs',
        st.weightStatus === 'Normal' ? 'Normal weight' : st.weightStatus, ACTS[st.activity][0]].filter(Boolean);
      $('[data-sofar]').innerHTML = chips.map(function (c) { return '<span>' + esc(c) + '</span>'; }).join('');
    }
    save();
  }

  function show(pane) {
    $$('.twq-step, .twq-res').forEach(function (p) { p.hidden = p.dataset.pane !== String(pane); });
    var res = pane === 7, n = typeof pane === 'number' ? pane : st.step;
    root.dataset.step = String(pane);
    $('.twq-grid').hidden = res;
    $$('[data-side]').forEach(function (s) { s.hidden = s.dataset.side !== String(Math.min(n, 6)); });
    var segs = res ? 5 : Math.min(n, 5);
    $$('.twq-prog li').forEach(function (li, i) { li.classList.toggle('on', i < segs); });
    var c = $('[data-twq-count]'), cm = $('[data-twq-count-m]');
    if (res) { c.innerHTML = 'Plan ready'; cm.textContent = 'Ready'; }
    else { c.innerHTML = 'Step ' + segs + ' of 5 <i>· about 1 min</i>'; cm.textContent = segs + '/5'; }
    $$('.twq-bar [data-back]').forEach(function (b) { b.hidden = res || n === 1 || pane === 'load'; });
    var bn = $('[data-bar-next]'); if (bn) { bn.hidden = res || pane === 'load'; bn.innerHTML = (n === 6 ? 'Show me ' + esc(poss(false)) + ' plan ' : 'Next ') + icon('arrow'); }
    $$('.twq-bar [data-order]').forEach(function (b) { b.hidden = !res; });
    root.classList.toggle('is-res', res);
  }

  function go(n, opts) {
    var prev = st.step;
    if (n !== 7 && prev >= 1 && prev <= 6 && !(opts && opts.silent)) trackStep(prev, n > prev ? 'next' : 'back');
    st.step = n; show(n);
    if (n === 7) renderResults(); else trackStep(n, 'view');
    refresh();
    var top = root.getBoundingClientRect().top + window.scrollY;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    if (n >= 1 && n <= 6) { var f = $('[data-pane="' + n + '"] input'); if (f && n !== 2 && window.matchMedia('(min-width: 900px)').matches) setTimeout(function () { f.focus({ preventScroll: true }); }, 50); }
  }

  function renderResults() {
    var r = st.result;
    if (!r) { go(1, { silent: true }); return; }
    var anchor = r.plans.length ? r.plans.reduce(function (b, x) { return Math.abs(x.rawDays - 28) < Math.abs(b.rawDays - 28) ? x : b; }, r.plans[0]) : r.all[1];
    var lb = { 1: '4.5lb', 2: '9lb', 3: '13.5lb', 4: '18lb', 5: '22.5lb', 6: '27lb' }[anchor.bags];
    $('[data-r="name"]').textContent = nm();
    var special = [];
    if (st.gender === 'female' && st.neutered === 'no' && st.repro !== 'none') special.push('Pregnant or nursing');
    if (st.weightStatus === 'Underweight' || st.weightStatus === 'Overweight') special.push(st.weightStatus);
    var rows = [['Breed', st.breed], ['Sex', st.gender === 'female' ? 'Good girl' : 'Good boy'], ['Weight', Math.round(st.weight) + ' lbs'], ['Age', (AGES[String(st.age)] || [''])[0]]];
    if (special.length) rows.push(['Special Requirements', special.join(', ')]);
    rows.push(['Daily Activity', ACTS[st.activity][2]]);
    $('[data-r="profile"]').innerHTML = rows.map(function (x) { return '<div><dt class="mono">' + x[0] + '</dt><dd>' + esc(x[1]) + '</dd></div>'; }).join('');
    var g = $('[data-r="goals"]');
    g.hidden = !st.goals.length;
    var labels = st.goals.map(function (id) { return GOAL[id] ? GOAL[id][1] : id; });
    $('[data-r="goal-sum"]').textContent = labels.join(', ');
    $('[data-r="goal-list"]').innerHTML = st.goals.filter(function (id) { return GOAL[id]; }).map(function (id) {
      var x = GOAL[id];
      return '<div class="twq-goal"><span class="tick">' + icon('check') + '</span><div><h3>' + esc(x[1]) + '</h3><p class="mono">' + esc(x[3]) + '</p><p>' + esc(x[4]) + '</p></div></div>';
    }).join('');
    $('[data-r="cups"]').textContent = (r.grams / G_PER_CUP / 2).toFixed(1) + ' cups';
    $('[data-r="kcal"]').textContent = r.kcal + ' kcal';
    $('[data-r="bag"]').textContent = lb;
    $('[data-r="bag-sub"]').textContent = '(' + anchor.bags + 'x 4.5lb bag' + (anchor.bags > 1 ? 's' : '') + ') · will last approximately ' + anchor.days + ' days';
    $$('[data-order]').forEach(function (a) { a.href = r.url; });
    /* Portion outside the 7-68 day plans: no plan options on the product page, so point them to us */
    var talk = $('[data-talk]');
    if (!talk) {
      talk = document.createElement('p'); talk.setAttribute('data-talk', '');
      talk.style.cssText = 'margin:16px 0 0;padding:14px 16px;background:var(--paper);color:var(--ink);border-radius:14px;font-size:14px;line-height:1.45';
      var order = $('.twq-plan .twq-order'); order.parentNode.insertBefore(talk, order);
    }
    talk.hidden = r.plans.length > 0;
    talk.innerHTML = esc(nm() || 'Your dog') + '’s portion falls outside our standard delivery plans. <a href="/pages/help" style="color:var(--plum);font-weight:600;text-decoration:underline">Talk to us</a> and we’ll set up the right plan.';
  }

  /* ---------- breed search ---------- */
  var bIn = $('#twqBreed'), bList = $('#twqBreedList');
  function renderBreeds(open) {
    var q = bIn.value.trim().toLowerCase();
    var list = BREEDS.filter(function (b) { return b === 'Mixed Breed' || b === 'Other' || b.toLowerCase().indexOf(q) > -1 || q === st.breed.toLowerCase(); });
    bList.innerHTML = list.map(function (b) { return '<li role="option" tabindex="-1" data-b="' + esc(b) + '"' + (b === st.breed ? ' aria-selected="true" class="on"' : '') + '>' + (b === st.breed ? icon('check') : '<i></i>') + esc(b) + '</li>'; }).join('');
    bList.hidden = !open; bIn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function pickBreed(b) { st.breed = b; bIn.value = b; renderBreeds(false); refresh(); }
  bIn.addEventListener('focus', function () { renderBreeds(true); });
  bIn.addEventListener('input', function () {
    var v = bIn.value.trim().toLowerCase(), m = BREEDS.filter(function (b) { return b.toLowerCase() === v; })[0];
    st.breed = m || ''; renderBreeds(true); refresh();
  });
  bIn.addEventListener('keydown', function (e) {
    var items = $$('li', bList); if (!items.length) return;
    var i = items.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') { e.preventDefault(); renderBreeds(true); items = $$('li', bList); (items[0]).focus(); }
    if (e.key === 'Enter') { e.preventDefault(); var first = items.filter(function (li) { return li.dataset.b !== 'Mixed Breed' && li.dataset.b !== 'Other'; })[0] || items[0]; if (bIn.value.trim()) pickBreed(first.dataset.b); }
    if (e.key === 'Escape') renderBreeds(false);
  });
  bList.addEventListener('keydown', function (e) {
    var items = $$('li', bList), i = items.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[i]).focus(); }
    if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) bIn.focus(); else items[i - 1].focus(); }
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pickBreed(document.activeElement.dataset.b); bIn.focus(); }
    if (e.key === 'Escape') { renderBreeds(false); bIn.focus(); }
  });
  bList.addEventListener('mousedown', function (e) { e.preventDefault(); });
  bList.addEventListener('click', function (e) { var li = e.target.closest('li'); if (li) pickBreed(li.dataset.b); });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-breed]')) renderBreeds(false); });

  /* ---------- sliders ---------- */
  var wIn = $('#twqWeight'), wOut = $('[data-weight-out]');
  function setWeight(v) {
    v = Math.max(1, Math.min(150, v)); v = v <= 40 ? Math.round(v) : Math.round(v / 5) * 5;
    st.weight = v; wIn.value = v; wOut.textContent = v >= 150 ? '150+ lbs' : v + ' lbs';
    wIn.style.setProperty('--pct', ((v - 1) / 149 * 100) + '%');
  }
  wIn.addEventListener('input', function () { setWeight(Number(wIn.value)); refresh(); });
  var aIn = $('#twqAct');
  function setAct(v) {
    st.activity = v; aIn.value = v; $('[data-act-out]').textContent = ACTS[v][0];
    $('[data-act-sub]').textContent = ACTS[v][1].replace('< ', 'under ') + ' a day';
    aIn.style.setProperty('--pct', ((v - 1) / 4 * 100) + '%');
    $$('.twq-act-l li').forEach(function (li, i) { li.classList.toggle('on', i + 1 === v); });
  }
  aIn.addEventListener('input', function () { setAct(Number(aIn.value)); refresh(); });

  /* ---------- goals ---------- */
  $('[data-goals]').innerHTML = GOALS.map(function (g) { return '<button type="button" class="twq-goalbtn" data-goal="' + g[0] + '" aria-pressed="false">' + icon(g[2]) + '<span>' + esc(g[1]) + '</span></button>'; }).join('');
  function syncGoals() { $$('[data-goal]').forEach(function (b) { var on = st.goals.indexOf(b.dataset.goal) > -1; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, a'); if (!t || !root.contains(t)) return;
    if (t.dataset.f && t.dataset.v !== undefined) {
      var f = t.dataset.f, v = t.dataset.v;
      st[f] = f === 'age' ? v : v;
      if (f === 'neutered' && v === 'yes') st.repro = 'none';
      refresh(); return;
    }
    if (t.dataset.goal) { var i = st.goals.indexOf(t.dataset.goal); if (i > -1) st.goals.splice(i, 1); else st.goals.push(t.dataset.goal); syncGoals(); refresh(); return; }
    if (t.hasAttribute('data-next')) { if (stepOk(st.step)) go(st.step + 1); return; }
    if (t.hasAttribute('data-bar-next')) { if (!stepOk(st.step)) return; if (st.step === 6) submit(true); else go(st.step + 1); return; }
    if (t.hasAttribute('data-back')) { if (st.step > 1 && st.step <= 6) go(st.step - 1); return; }
    if (t.hasAttribute('data-submit')) { if (stepOk(6)) submit(true); return; }
    if (t.hasAttribute('data-skip')) { st.email = ''; $('#twqEmail').value = ''; submit(false); return; }
    if (t.hasAttribute('data-edit')) { go(1, { silent: true }); return; }
    if (t.hasAttribute('data-restart')) {
      st = { step: 1, name: '', gender: '', age: '', breed: '', weight: 10, weightStatus: '', activity: 2, neutered: '', repro: 'none', goals: [], email: st.email, result: null };
      init(); go(1, { silent: true }); return;
    }
  });
  $('#twqName').addEventListener('input', function (e) { st.name = e.target.value; refresh(); });
  $('#twqEmail').addEventListener('input', function (e) { st.email = e.target.value; refresh(); });
  $('#twqEmail').addEventListener('blur', function (e) { var v = e.target.value.trim().toLowerCase(); e.target.value = v; st.email = v; refresh(); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('#twqName, #twqEmail')) { e.preventDefault(); if (!stepOk(st.step)) return; if (st.step === 6) submit(true); else go(st.step + 1); }
  });

  function init() {
    $('#twqName').value = st.name; $('#twqEmail').value = st.email; bIn.value = st.breed;
    setWeight(st.weight || 10); setAct(st.activity || 2); syncGoals(); renderBreeds(false);
  }
  init();
  var start = st.step === 7 && st.result ? 7 : Math.min(Math.max(st.step || 1, 1), 6);
  st.step = start; show(start);
  if (start === 7) renderResults(); else trackStep(start, 'view');
  refresh();
})();
